import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { BaseButton as Button, Button as ButtonMemoized } from '../../Button/Button.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NavigatorButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var align = _ref.align,
    size = _ref.size,
    variant = _ref.variant,
    visible = _ref.visible,
    disabled = _ref.disabled,
    accessibilityLabel = _ref.accessibilityLabel,
    attributes = _ref.attributes,
    onClick = _ref.onClick;
  var icon = align === 'start' ? 'fill.arrow.thin-back' : 'fill.arrow.thin-forward';
  var buttonState = disabled || !visible ? 'disabled' : 'enabled';
  var effectiveOnClick = visible ? onClick : undefined;
  var sharedButtonProps = _objectSpread(_objectSpread({}, attributes), {}, {
    size: size,
    state: buttonState,
    onClick: effectiveOnClick,
    variant: 'icon',
    hierarchy: 'tertiary',
    leadingIcon: icon,
    'aria-label': accessibilityLabel
  });
  var navigatorVariants = function navigatorVariants() {
    if (variant === 'inside') {
      return /*#__PURE__*/React.createElement(Button, _extends({}, sharedButtonProps, {
        ref: ref,
        floating: true
      }));
    }
    if (variant === 'inside-floating') {
      return /*#__PURE__*/React.createElement(ButtonMemoized, _extends({}, sharedButtonProps, {
        ref: ref
      }));
    }
    return null;
  };
  return navigatorVariants();
});
var NavigatorButtonMemoized = /*#__PURE__*/React.memo(NavigatorButton);
NavigatorButtonMemoized.displayName = 'NavigatorButton';

export { NavigatorButtonMemoized as NavigatorButton };
//# sourceMappingURL=NavigatorButton.js.map
